import { createSelector } from 'reselect'
import userAcademicLevel from 'redux/selectors/user/academic_level_selector'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'

const getStoreAccess = state => state.user.extra ? !!state.user.extra.shouldHideStore : false
const user_store_access_selector = createSelector(
	[ getStoreAccess, userAcademicLevel ],
	(shouldHideStore, userAcademicLevel) => shouldHideStore || userAcademicLevel === academicLevelTypes.HIGHER_ED
)

export default user_store_access_selector
